import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../icon/Icon.jsx';
import Text from '../text/Text.jsx';

const Tag = ({
  label,
  onClick,
  href,
  target,
  size,
  variant,
  icon,
  className
}) => {
  const textVariant = size === 'large' ? 'button' : 'copy-label';

  const classes = `tag tag--${size} tag--${variant} ${
    icon ? `tag--has-icon` : ''
  } ${className}`;

  if (href) {
    return (
      <a href={href} className={classes} title={label} target={target}>
        <Text tag="span" variant={textVariant}>
          {label}
        </Text>
        {icon && <Icon id={icon} />}
      </a>
    );
  }

  if (onClick) {
    return (
      <button type="button" className={classes} onClick={onClick} title={label}>
        <Text tag="span" variant={textVariant}>
          {label}
        </Text>
        {icon && <Icon id={icon} />}
      </button>
    );
  }

  return (
    <div className={classes}>
      <Text tag="span" variant={textVariant}>
        {label}
      </Text>
      {icon && <Icon id={icon} />}
    </div>
  );
};

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary']),
  size: PropTypes.oneOf(['small', 'large'])
};

Tag.defaultProps = {
  href: undefined,
  icon: undefined,
  target: undefined,
  onClick: undefined,
  variant: 'primary',
  size: 'large',
  className: ''
};

export default Tag;
